"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var ng2_bs3_modal_1 = require("@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal");
var modal_service_1 = require("./modal.service");
var LoadingModalComponent = (function () {
    function LoadingModalComponent(modalService) {
        this.modalService = modalService;
    }
    LoadingModalComponent.prototype.ngOnInit = function () {
        this.instanceCount = 0;
        this.onCloseModal();
        this.modalService.registerLoadingModalComponent(this);
    };
    LoadingModalComponent.prototype.ngOnDestroy = function () {
        this.onCloseModal();
        this.modalService.clearLoadingModalComponent();
        this.instanceCount = 0;
    };
    LoadingModalComponent.prototype.open = function (message) {
        if (message === void 0) { message = 'Loading...'; }
        this.message = message;
        this.instanceCount = this.instanceCount + 1;
        if (this.instanceCount === 1) {
            this.modal.open();
        }
    };
    LoadingModalComponent.prototype.onCloseModal = function () {
        if (this.instanceCount > 0) {
            this.instanceCount = this.instanceCount - 1;
        }
        if (this.modal && this.instanceCount === 0) {
            this.modal.close();
        }
    };
    return LoadingModalComponent;
}());
__decorate([
    core_1.ViewChild('loadingModal'),
    __metadata("design:type", ng2_bs3_modal_1.ModalComponent)
], LoadingModalComponent.prototype, "modal", void 0);
LoadingModalComponent = __decorate([
    core_1.Component({
        selector: 'loading-modal',
        template: "<modal #loadingModal class=\"panel-primary\" cssClass=\"loading-modal\" [backdrop]=\"'static'\" [keyboard]=\"false\">     <modal-body>         <i class=\"fa fa-spinner fa-spin fa-pulse\"></i>{{message}}     </modal-body> </modal>"
    }),
    __metadata("design:paramtypes", [modal_service_1.ModalService])
], LoadingModalComponent);
exports.LoadingModalComponent = LoadingModalComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/loading-modal.component.js